import { Parameter } from './../../../../@core/interfaces/common/parameter';
import { Observable } from 'rxjs';

export interface BloodIndentIssueDetailsParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
}

export interface BloodIndentIssueDetails {
  blIssueMstId?:number;
  blIndentTrackId?:number;
  blRowId:number;
  blBloodId:number;
  blUnit:string;
  blIssueQty:number;
  blExpdate:string;
  createdBy:string;
  createdDate:any;
  updatedBy:string;
  updatedDate:string;
  branchId: string;
  tenantId: string;
}

export abstract class BloodIndentIssueDetailsData {
  abstract list(url: string): Observable<any[]>;
  abstract searchList(url: string,data:any): Observable<any>;
  abstract create(url: string,data: any): Observable<any>;
  abstract update(url: string,data: any): Observable<any>;
  abstract delete(url: string): Observable<any>;
}
